import axios from 'axios';
import { getErrorMessage } from '../utils/RequestUtils';
import { getToken, isAuthenticated } from './AuthService';
import { getAuthApiPath, AUTH_API_VERSION } from '../store/modules/AuthActions';

const api = axios.create();
const SHOW_ERROR_ON_CONSOLE = 'SHOW_ERROR_ON_CONSOLE';

export const API_STATUS_REQ_CREATE = 'Criacao';
export const API_STATUS_REQ_UPDATE = 'Edicao';

export const errorOnConsoleIsActivate = () => {
  return typeof window.localStorage.getItem(SHOW_ERROR_ON_CONSOLE) === 'string'
    ? true
    : false;
};

api.interceptors.request.use(async function (config) {
  if (
    isAuthenticated() &&
    config.url.indexOf(getAuthApiPath(AUTH_API_VERSION)) === -1
  ) {
    config.headers = {
      ...(config && config.headers ? config.headers : {}),
      Authorization: `Bearer ${getToken()}`
    };
  }
  return config;
});

api.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error.response === undefined) {
      return Promise.reject({
        response: {
          statusText: null,
        },
      });
    }
    if (errorOnConsoleIsActivate()) {
      console.log(error.response);
    }
    if (
      typeof error === 'object' &&
      typeof error.response === 'object' &&
      typeof error.response.status === 'number' &&
      typeof error.response.data === 'object' &&
      error.response.status !== 200
    ) {
      error.response.statusText = getErrorMessage(error.response.data);
    }
    if (
      typeof error.response.statusText === 'string' &&
      error.response.statusText.trim().length === 0
    ) {
      error.response.statusText = null;
    }
    return Promise.reject(error);
  }
);

export default api;